import { Box, Button, Tooltip } from '@mui/material';
import { PointOfSale as PointOfSaleIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const POS_URL = 'https://pos.posanto.com/';

function POSToggleButton() {
  const { t } = useTranslation();
  const handleOpenPOS = () => {
    window.open(POS_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title={t('goto.pos')} arrow>
      <Button
        variant="outlined"
        size="small"
        startIcon={<PointOfSaleIcon />}
        onClick={handleOpenPOS}
        aria-label={t('goto.pos')}
        sx={{
          mr: { xs: 0.5, sm: 1 },
          // Icon only on a phone.
          minWidth: { xs: 36, sm: 64 },
          px: { xs: 0.75, sm: 1.25 },
          '& .MuiButton-startIcon': { mr: { xs: 0, sm: 1 }, ml: { xs: 0 } },
          borderColor: 'primary.main',
          color: 'primary.main',
          '&:hover': {
            backgroundColor: 'primary.main',
            color: 'white'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
          POS
        </Box>
      </Button>
    </Tooltip>
  );
}

export default POSToggleButton;
